import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSlide } from "../../tutorial.models";

export const CLOSING_SLIDE: TutorialSlide[] = [
    {
        key: 'Close-Tutorial',
        title: 'Settings Tutorial Complete!',
        messages: [
            { text: "CONGRATULATIONS! You have reached the end of the settings tutorial" },
        ],
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        //position: { vertical: 'center', horizontal: 'center' }, Test the position later.
        dimensions: { width: '450px' },
        actions: [
            {
                text: 'Close Tutorial',
                color: 'primary',
                actionName: SlideAction.SHOW_NOW, //This will trigger the show docters options
            },
        ],
        position: { x: 700, y: 350 },
        hideDoNotShowAgain: true,
        //progressBar: 100,
        hideConditions: [
            // { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            // { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            // { condition: SlideHidePageCondition.COLLEAGUE_ADDED, type: SlideHideConditionType.OR },
        ],
    },
];